import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import { getRecomAnonymeAsync, getConcurrentsAnonymeAsync, getPanneauxSousContratAnonymeAsync } from '@/api/recom/recom_gescom';
import * as allTypes from '@/store/mutation-type';
import * as types from '@/store/modules/recommandation-mutation-type';
import { RAYON_DEFAULT } from '@/configurations/configurationCarto';
import gestionErreur from '@/services/general/gestionErreur';
import genererConcurrents from '@/services/concurrent/concurrent';
import { recommandationMapping, lignesCommandeToPanneaux} from '@/services/recommandation/recommandationMapping';

function initialState() {
  return {
    hash: null,
    recommandation: null,
    rayon: RAYON_DEFAULT,
    concurrents: [],
    nbreConcurrents: 0,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_RECOMMANDATION](state, data) {
    state.recommandation = data;
  },
  [types.SET_ICON_MARKER_PDV](state, icon) {
    set(state.recommandation, 'pointDeVente.iconMarker', icon);
  },
  [types.SET_HASH](state, val) {
    state.hash = val;
  },
  [types.SET_FILTER_RAYON](state, rayon) {
    state.rayon = rayon;
  },
  [types.SET_CONCURRENTS](state, concurrents) {
    state.concurrents = concurrents;
  },
  [types.SET_NBRE_CONCURRENTS](state, nbreConcurrents) {
    state.nbreConcurrents = nbreConcurrents;
  },
};

const actions = {
  getRecom: async ({ commit}) => {
    const devis = (await getRecomAnonymeAsync()).data.result;
    let panneauSousContrat = [];
    if (devis.afficherPanneauxSousContrat) {
      const ligneSousContrat = (await getPanneauxSousContratAnonymeAsync())
        .data
        .result
        .filter(l => l.prisEnCompte)
        .map(l => l.ligneCommande);
      panneauSousContrat = lignesCommandeToPanneaux(ligneSousContrat, devis.societe);
    }
    const recom = recommandationMapping(devis);

    if (panneauSousContrat.length > 0) {
      recom.panneaux.push(...panneauSousContrat);
    }

    commit(types.SET_RECOMMANDATION, cloneDeep(recom));
    return {};
  },
  recupererConcurrents: async({ commit, getters }) => {
    let latitude = get(getters.pdv, 'adressePostale.latitude', 0);
    if (!latitude) latitude = 0;
    let longitude = get(getters.pdv, 'adressePostale.longitude', 0);
    if (!longitude) longitude = 0;
    try {
      const payload = {
        limit: 9999,
        query: {
          coordonnees: {
            latitude: latitude,
            longitude: longitude,
            rayon: getters.rayon,
          },
        },
      };
      const res = (await getConcurrentsAnonymeAsync(payload)).data.result;
      const { data, nbreReelConcurrent } = genererConcurrents(getters.pdv, res.items);
      commit(types.SET_CONCURRENTS, data);
      commit(types.SET_NBRE_CONCURRENTS, nbreReelConcurrent);
    } catch (e) {
      gestionErreur('Erreur lors de la récupération des concurrents', e);
    }
  },
};

const getters = {
  hash: (state) => state.hash,
  recom: (state) => state.recommandation,
  commercial: (state) => {
    if (!state.recommandation) return null;
    return state.recommandation.commercial;
  },
  societe: (state) => {
    if (!state.recommandation) return null;
    return state.recommandation.societe;
  },
  pdv: (state) => {
    if (!state.recommandation) return null;
    return state.recommandation.pointDeVente;
  },
  panneaux: (state) => {
    if (!state.recommandation) return [];
    return state.recommandation.panneaux;
  },
  rayon: (state) => {
    return state.rayon;
  },
  concurrents: (state) => {
    return state.concurrents;
  },
  nbreConcurrents: (state) => {
    return state.nbreConcurrents;
  },
  pdvConcurrentSelected: (state) => {
    const enfantsSecteur = state.concurrents.flatMap(s => s.children);
    const pdvsAvecMarque = enfantsSecteur.flatMap(e => e.children);
    const pdvsSansMarque = enfantsSecteur.filter(e => e.isPdv);
    return [...pdvsAvecMarque, ...pdvsSansMarque].filter(c => c.selected);
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
